module.exports = __webpack_public_path__ + "static/media/How to update client visa information.e50b35d6.png";